import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Send, CheckCircle } from "lucide-react";
import { useAboutRequest } from "@/hooks/profile/useAboutRequest";
import { useProfileTracking } from "@/v2/hooks/profiles/useProfileTracking";
import { ProfileData } from "@/v2/hooks/profiles/useProfiles";

interface AboutRequestButtonProps {
  username: string;
  profileId: string;
  variant?: "default" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  profile?: ProfileData;
}

const AboutRequestButton = ({
  username,
  profileId,
  variant = "outline",
  size = "sm",
  profile,
}: AboutRequestButtonProps) => {
  const { handleAboutRequest, loading } = useProfileTracking();
  const [isRequestSent, setIsRequestSent] = useState(false);
  return (
    <div className="mt-2 flex justify-center">
      {!isRequestSent ? (
        <Button
          onClick={() =>
            handleAboutRequest(profile).then((res) => {
              if (res) {
                setIsRequestSent(true);
              }
            })
          }
          disabled={loading.about}
          variant={variant}
          size={size}
          className="flex items-center gap-2 mx-auto"
        >
          <Send className="h-4 w-4" />
          Request about info
          {loading.about && <span className="ml-2 animate-spin">⏳</span>}
        </Button>
      ) : (
        <div className="flex text-center justify-center items-center gap-2 text-sm text-green-600 dark:text-green-400 mx-auto">
          <CheckCircle className="h-4 w-4" />
          Request sent
        </div>
      )}

      {/* {error && <p className="mt-1 text-xs text-destructive">{error}</p>} */}
    </div>
  );
};

export default AboutRequestButton;
